import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ApiError } from "go-core/api/types";
import { FormErrorMessageApi } from "go-form/components/FormErrorMessage";
import { PriceConfiguratorAddonApi, PriceConfiguratorAddonTermsApi } from "../../../../../../../../services/Api/types";
import { getParsedTermsNameToSnakeCase } from "./services";

interface Props {
	show: boolean;
	onHide: () => void;
	terms: PriceConfiguratorAddonTermsApi;
	handleAddAddon?: (addon: PriceConfiguratorAddonApi, skipRules?: boolean, termsAccepted?: boolean) => void;
	handleAccept?: () => void;
	addon?: PriceConfiguratorAddonApi;
	submitButtonTitle?: string;
}

const AddonTermsModal = ({ show, onHide, terms, handleAddAddon, addon, handleAccept, submitButtonTitle }: Props) => {
	const { t } = useTranslation();
	const [checked, setChecked] = useState(false);
	const [errors, setErrors] = useState<ApiError[]>([]);

	const handleAdd = () => {
		if (!checked) {
			setErrors([
				{
					message: "must_accept_terms",
					code: "must_accept_terms",
					field: "addon_terms",
				},
			]);
			return;
		}

		setErrors([]);

		if (handleAddAddon && addon) {
			handleAddAddon(addon, true, checked);
		}

		if (handleAccept) {
			handleAccept();
		}

		onHide();
	};

	const handleCancel = () => {
		onHide();
	};

	const title = addon
		? `${t("modules.subscription.field.addon_terms.title")} "${addon.name}"`
		: t("modules.subscription.field.addon_terms.title");

	return (
		<Modal show={show} onHide={onHide}>
			<Modal.Header closeButton>
				<Modal.Title>{title}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div>
					<Form.Group className="form-group">
						<Form.Check
							id="addon_terms"
							name="addon_terms"
							onChange={(e) => setChecked(e.target.checked)}
							checked={checked}
							required
							label={
								<>
									{`${t("modules.subscription.action.accept.title")} `}
									<a target="_blank" href={terms.url} rel="noreferrer">
										{t(
											`enums.subscriptions.addon.terms.${getParsedTermsNameToSnakeCase(
												terms.name
											)}`
										)}
									</a>
								</>
							}
							className="ms-2 mb-0"
						/>
						<FormErrorMessageApi errors={errors} field="addon_terms" />
					</Form.Group>
				</div>
			</Modal.Body>
			<Modal.Footer>
				<Button onClick={handleAdd} type="submit">
					{submitButtonTitle ?? t("lib:common.action.add")}
				</Button>
				<Button onClick={handleCancel} variant="light">
					{t("lib:common.action.cancel")}
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default AddonTermsModal;

// t("enums.subscriptions.addon.terms.virtual_cash_register");
